/** Javascript utility functions and objects
 * 
 * - debug(output, scope)
 * - new_readyObject(initFn)
 * - plural(n, word)
 */

const testScopes = [
   //'sbapp',
   //'statusdata',
   //'countsdata',
   //'sbuser',
]
function _logDebugContent(output, scope){
   let logStr = JSON.stringify(output)
   if( scope ){
      if(testScopes.includes(scope)) 
         console.log(`${scope}: ${logStr}`)
   } else {
      console.log(logStr)
   }
}
function _noDebugLog(){}
// We can use debug=noDebugLog for production
export const debug = _logDebugContent


/** Create a ReadyObject that initialises itself on first use.
 * 
 * @param function initFn initialisation function to be called at first use.
 *  
 * A ReadyObject has a `ready` method that returns the object's data/value.
 * The first time `ready` is called, it calls the initialisation function
 * and stores the data it returns. On subsequent calls, `ready()` returns
 * the data without further initialisation.
 */
 export function new_ReadyObject(initFn){
   let myObject = null
   return {
      ready(initData){
         if(myObject==null) myObject = initFn(initData)
         return myObject
      }
   }
}

/** Wait for any events currently in the queue */
export async function processPendingEvents(extraDelay = 0){
   if(extraDelay>0) return new Promise((resolve)=>setTimeout(resolve, extraDelay))
   else return new Promise((resolve)=>setTimeout(resolve))
}

/** Pluralise word when appropriate
 * 
 */
export function plural(n, word){
   const special={}
   if( Math.abs(n)==1 ) return word
   else if(special.hasOwnProperty(word)) return special[word]
   else return (word + 's')
}